import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-002aec09"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "더낸세금", -1))
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 사용후기를 들어보세요. ")
const _hoisted_3 = ["onClick", "onMouseover"]
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "button" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cover" }, null, -1))
const _hoisted_7 = { class: "double-quote" }
const _hoisted_8 = { class: "content" }
const _hoisted_9 = { class: "footer" }
const _hoisted_10 = {
  key: 0,
  class: "more-wrapper"
}
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" 후기 더보기 ")

import { ref, onMounted } from 'vue' 
import Text from '@/components/common/TextComponent.vue'
import { FONT_WEIGHT, COLOR_SET } from '@/styles/variables'
import VideoPlayButton from '@/styles/icon/VideoPlayButton.vue'
import DoubleQuote from '@/styles/icon/DoubleQuote.vue'

import { videos } from '../constants/videos'
import { setAnimationObserver } from '../libs/observer'
import VideoPlayer from './VideoPlayer.vue'


export default /*#__PURE__*/_defineComponent({
  name: 'LandingVideo',
  setup(__props) {

const selectedVideoUrl = ref('')
const showVideoPlayer = ref(false)
const hoverTarget = ref()
const showMore = ref(false)
const showAnimation = ref(false)
const wrapper = ref()

const handlePlayVideo = (targetUrl: string) => {
  selectedVideoUrl.value = targetUrl
  showVideoPlayer.value = true
}

const handleHoverIn = (targetId: number) => {
  hoverTarget.value = targetId
}

const handleHoverOut = () => {
  hoverTarget.value = null
}

onMounted(() => {
  setAnimationObserver(wrapper.value, () => { showAnimation.value = true }, 0.2)
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (showVideoPlayer.value)
      ? (_openBlock(), _createBlock(VideoPlayer, {
          key: 0,
          "target-url": selectedVideoUrl.value,
          onClose_modal: _cache[0] || (_cache[0] = ($event: any) => (showVideoPlayer.value = false))
        }, null, 8, ["target-url"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      id: "review_main",
      ref_key: "wrapper",
      ref: wrapper,
      class: "wrapper"
    }, [
      _createVNode(Text, {
        class: _normalizeClass(["title animation-show", {show: showAnimation.value}]),
        size: "64px",
        "mobile-size": "30px",
        "line-height": "1.25",
        weight: _unref(FONT_WEIGHT).bold,
        "word-break": "keep-all",
        "text-align": "center",
        width: "550px",
        "mobile-width": "300px"
      }, {
        default: _withCtx(() => [
          _hoisted_1,
          _hoisted_2
        ]),
        _: 1
      }, 8, ["class", "weight"]),
      _createElementVNode("div", {
        class: _normalizeClass(["video-wrapper animation-show delay", {more: showMore.value, show: showAnimation.value}])
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(videos), (item) => {
          return (_openBlock(), _createElementBlock("div", {
            key: item.id,
            class: "video-item",
            onClick: ($event: any) => (handlePlayVideo(item.videoUrl)),
            onMouseover: ($event: any) => (handleHoverIn(item.id)),
            onMouseout: handleHoverOut
          }, [
            _createElementVNode("img", {
              src: item.thumbnailUrl
            }, null, 8, _hoisted_4),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(VideoPlayButton, {
                "mobile-size": 60,
                opacity: hoverTarget.value === item.id ? '1' : '0.7'
              }, null, 8, ["opacity"])
            ]),
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, [
              _createVNode(DoubleQuote, {
                "mobile-height": 17,
                "mobile-width": 43
              })
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", null, [
                _createVNode(Text, {
                  color: _unref(COLOR_SET).blue01,
                  weight: _unref(FONT_WEIGHT).bold,
                  size: "40px",
                  "mobile-size": "18px"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.title), 1)
                  ]),
                  _: 2
                }, 1032, ["color", "weight"]),
                _createVNode(Text, {
                  size: "32px",
                  "mobile-size": "16px"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.description), 1)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createVNode(Text, {
                  size: "24px",
                  "mobile-size": "12px"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.company), 1)
                  ]),
                  _: 2
                }, 1024),
                _createVNode(Text, {
                  size: "24px",
                  "mobile-size": "12px",
                  weight: _unref(FONT_WEIGHT).bold
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.name), 1)
                  ]),
                  _: 2
                }, 1032, ["weight"]),
                _createVNode(Text, {
                  size: "24px",
                  "mobile-size": "12px",
                  weight: _unref(FONT_WEIGHT).bold
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.duty), 1)
                  ]),
                  _: 2
                }, 1032, ["weight"])
              ])
            ])
          ], 40, _hoisted_3))
        }), 128))
      ], 2),
      (!showMore.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("div", {
              class: "more-button",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (showMore.value = true))
            }, [
              _createVNode(Text, {
                size: "20px",
                weight: _unref(FONT_WEIGHT).bold,
                color: _unref(COLOR_SET).blue01
              }, {
                default: _withCtx(() => [
                  _hoisted_11
                ]),
                _: 1
              }, 8, ["weight", "color"])
            ])
          ]))
        : _createCommentVNode("", true)
    ], 512)
  ], 64))
}
}

})